import { useRef, useState } from "react";
import { Col, Row } from "antd";
import styles from "./ProfileUploadPhoto.module.css";
import { SubmitButton, TextComponent } from "../../../../components";
import uploadImg from "../../../../assets/staticImages/addImg.png";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";
import { showAlert } from "../../../../Store/Actions/GeneralActions";

const ProfileUploadPhoto = () => {
  const user = useSelector((state)=>state.AuthReducer.user);
console.log(user?.photos)

  const FileInput = useRef();
  const [images, setImages] = useState([...user?.photos]);
  // console.log("imagesssssssss", images);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const Upload = () => {
    // if (images.length > 0) {
        dispatch(AuthMiddleware.updateVendorProfile({ images })).then(() => navigate(-1)).catch()
    // }
    // else {
    //     dispatch(showAlert({ message: 'Please upload images first.!', status: 400 }))
    // }
}

  // const addImage = (e) => {
  //   e.preventDefault();
  //   if (!images) {
  //     alert("please upload image");
  //   } else {
  //     // const lastId = images.length > 0 ? images[images.length - 1]?.id : 1;
  //     const newImages = [...e.target.files].map((img, i) => {
  //       return {
  //         // id: lastId + i + 1,
  //         image: img,
  //       };
  //     });
  //     setImages((prev) => [...prev, ...newImages]);
  //     //   setuploadImage(null);
  //   }
  // };

  const deleteImg = (index) => {
    // setImages((prev) => prev.filter((image) => image.id !== id));
    let imgObj = [...images]
    imgObj?.splice(index, 1)
    setImages(imgObj)
  };
  // console.log(images);
  return (
    <>
      <Row>
        <TextComponent textClass={styles.heading}>Gallery</TextComponent>
      </Row>
      <Row gutter={[16, 16]} className={styles.imagesRow}>
        {images?.map((img, index) => (
          <Col
            key={img.id}
            xs={24}
            sm={12}
            lg={8}
            style={{ position: "relative" }}
          >
            <img src={img?.id ? img?.image : URL.createObjectURL(img?.image)} className={styles.Img} />
            <IoClose
              size={25}
              style={{
                position: "absolute",
                top: "10px",
                right: "20px",
                cursor: "pointer",
              }}
              onClick={() => deleteImg(index)}
            />
          </Col>
        ))}
        <Col xs={24} md={12} lg={8}>
          <div
            className={styles.ImgDiv}
            onClick={() => FileInput.current.click()}
          >
            <img src={uploadImg} />
          </div>
          <input
            type="file"
            multiple
            ref={FileInput}
            accept={"image/*"}
            // onChange={(e) => {
            //   //   setuploadImage(URL.createObjectURL(e.target.files[0]));
            //   addImage(e);
            // }}
            onChange={(el) =>
              el.target.files?.length &&
              setImages([
                ...images,
                ...Array.from(el.target.files).map(
                  (file, i) => (
                    // console.log("file.name", file),
                    {
                      image: file,
                      uri: window.URL.createObjectURL(file),
                      media_type: "image",
                      fileName: file.name,
                      // id: `${imgs.length + i + 12}`,
                    }
                  )
                ),
              ])
            }
            style={{ display: "none" }}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={12} lg={8}>
          <SubmitButton title="Save" onClick={Upload} />
        </Col>
      </Row>
    </>
  );
};

export default ProfileUploadPhoto;
